// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__npq+H","active":"RoomScene_active__HaOhL"};